import WhatsNewDropdown from './WhatsNewDropdown'

export default WhatsNewDropdown
